import React from 'react';
import Payments from 'api/api-payments';
import { FormBuilder } from '../forms/form';
import { Toggle } from '../buttons/toggle-button';
import { getWebEnv } from 'api/api-env';
import { FormattedMessage, injectIntl } from "react-intl";

class RecipientForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      accountType: 'company',
      name: '',
      errorMessage: ''
    };

    this.updateAccountType = this.updateAccountType.bind(this);
    this.accountTypeToggle = this.accountTypeToggle.bind(this);
    this.finalCallback = this.finalCallback.bind(this);
    this.addPayoutToProfile = this.addPayoutToProfile.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount () {
    getWebEnv((env) => {
      Stripe.setPublishableKey(env.stripe.stripe_public_key);
    });
  }

  updateAccountType (value) {
    this.setState({ accountType: value });
  }

  accountTypeToggle () {
    return (<Toggle
      onLabel={this.props.intl.formatMessage({ id: 'shared_components.recipient_form.account_type_on_label', defaultMessage: 'Business' })}
      offLabel={this.props.intl.formatMessage({ id: 'shared_components.recipient_form.account_type_off_label', defaultMessage: 'Personal' })}
      onValue="company"
      offValue="individual"
      selectedValue="company"
      changeCallback={this.updateAccountType}
      errorMsg={this.props.intl.formatMessage({ id: 'shared_components.recipient_form.account_type_error', defaultMessage: 'Please select your account type' })}
      ref="bank-account-toggle"
      label={this.props.intl.formatMessage({ id: 'shared_components.recipient_form.account_type_label', defaultMessage: 'Select Account Type' })}
    />);
  }

  finalCallback (hasError) {
    if (!hasError) {
      this.props.callback();
    }
  }

  addPayoutToProfile (token, callback) {
    const payload = {
      bank_account_token: token,
      legal_name: $('#account-holder-name').val(),
      type: this.state.accountType == 'company' ? 'corporation' : 'individual'
    };

    Payments.updateBank(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), payload, (response) => {
      if (200 !== response.statusCode) {
        this.setState({
          errorMessage: this.props.intl.formatMessage({ id: 'shared_components.recipient_form.payout_error', defaultMessage: 'Something went wrong. Please try again.' })
        });
        callback(true);
      } else {
        callback();
      }
    });
  }

  submitForm (form, callback) {
    Payments.createStripeToken('ach-form', 'bank-account', (status, response) => {
      if (response.error) {
        this.setState({ errorMessage: response.error.message });
        callback(true);
      } else {
        this.addPayoutToProfile(response.id, callback);
      }
    });
  }

  render () {
    const isIndividual = 'individual' === this.state.accountType;
    /* values below related to bank account holder */
    const nameFieldLabel = isIndividual
      ? this.props.intl.formatMessage({ id: 'shared_components.recipient_form.name_label', defaultMessage: 'Name' })
      : this.props.intl.formatMessage({ id: 'shared_components.recipient_form.organization_label', defaultMessage: 'Organization' });
    const nameInputPlaceholder = isIndividual
      ? this.props.intl.formatMessage({ id: 'shared_components.recipient_form.name_input_placeholder', defaultMessage: 'Full Legal Name' })
      : this.props.intl.formatMessage({ id: 'shared_components.recipient_form.business_input_placeholder', defaultMessage: 'Legal Business Name' });
    const nameMoreInfo = isIndividual
      ? this.props.intl.formatMessage({ id: 'shared_components.recipient_form.name_more_info', defaultMessage: 'Your legal name will be used to verify your identity and must match what is on record when you submit your SSN.' })
      : this.props.intl.formatMessage({ id: 'shared_components.recipient_form.business_more_info', defaultMessage: 'Your legal business name will be used to verify your company identity and must match what is on record when you submit your EIN.' });

    /*
      account type toggle us where user selects account type, but value in form
      is populated by state and ready by Stripe from account_holder input field
    */
    const formInputs = [
      {
        custom: this.accountTypeToggle
      },
      {
        inputFieldName: 'hidden_account_type',
        dataAttributes: { 'data-stripe': 'account_holder_type' },
        hideRequired: true,
        setVal: this.state.accountType
      },
      {
        elementID: 'account-holder-name',
        inputFieldName: 'account_holder',
        optional: false,
        dataAttributes: { 'data-stripe': 'account_holder_name' },
        label: nameFieldLabel,
        labelSize: 'col-xs-12',
        placeholder: nameInputPlaceholder,
        helperText: nameMoreInfo
      },
      {
        inputFieldName: 'account_number',
        optional: false,
        colSize: 'col-xs-6 half-padding-right',
        labelSize: 'col-xs-12',
        dataAttributes: { 'data-stripe': 'account_number' }
      },
      {
        inputFieldName: 'routing_number',
        optional: false,
        colSize: 'col-xs-6 half-padding-left',
        labelSize: 'col-xs-12',
        dataAttributes: { 'data-stripe': 'routing_number' }
      },
      {
        inputFieldName: 'hidden_country_code',
        elementID: 'month',
        dataAttributes: { 'data-stripe': 'country' },
        defaultVal: 'US'
      }
    ];

    return (<div style={{ marginLeft: 45, marginRight: 45 }}>
      <h3 className="heading text-center">
        <FormattedMessage
          id='shared_components.recipient_form.update_bank_account'
          defaultMessage='Update your bank account'
        />
      </h3>
      <p className="form-standard">
        <FormattedMessage
          id='shared_components.recipient_form.update_bank_account_description'
          defaultMessage='Please enter your banking information to approve this booking. We’ll directly deposit all of your payouts into your account.'
        />
      </p>
      <FormBuilder
        formname="transactableBankAccount"
        id="ach-form"
        formStyle="standard"
        formInputs={formInputs}
        errorText={this.state.errorMessage}
        submitAction={this.submitForm}
        submitCallback={this.finalCallback}
        buttonText={this.props.intl.formatMessage({ id: 'shared_components.recipient_form.button_update', defaultMessage: 'Update' })}
      />
    </div>);
  }
}

const __e_RecipientForm = injectIntl(RecipientForm);

export { __e_RecipientForm as RecipientForm };